'use client';

import {useEffect, useState} from 'react';

type Props = {
  country: Country;
};

const CountryMap = ({country}: Props) => {
  const [mapSvg, setMapSvg] = useState<any>('');

  useEffect(() => {
    try {
      fetch(`/countries/${country.isoName.toLowerCase()}.svg`)
        .then((response) => response.text())
        .then(setMapSvg);
    } catch (error) {
      console.log(error);
    }
  }, [country]);

  return (
    <div className="relative w-full h-0 pb-[100%]">
      <div className="absolute w-full h-full">
        {mapSvg ? (
          <div
            className="animate-appear w-full h-full [&>svg]:w-full [&>svg]:h-full [&>svg]:drop-shadow-2xl [&>svg_path]:fill-white dark:[&>svg_path]:fill-(--button-bg) [&>svg_path]:stroke-[#cdccd1] dark:[&>svg_path]:stroke-[#473e4b] [&>svg_path]:stroke-[30px]"
            dangerouslySetInnerHTML={{__html: mapSvg}}
          />
        ) : null}
      </div>
    </div>
  );
};

export default CountryMap;
